<template>
  <div v-if="getPermission.do.view || getPermission.doReadOnly.view">
    <do-header-form ref="DoHeaderForm" mode="CREATE"/>
    <do-header-form ref="DoHeaderFormChange" mode="UPDATE"/>
    <do-header-form ref="DoHeaderFormCopy" mode="COPY"/>
    <do-item-form ref="DoItemFormCreate" mode="createItem"/>

    <md-card class="searchPanel">
      <md-card-content v-if="searchRequest"> 
        <div class="md-layout md-gutter">
          <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">
            <div class = "inputBox">
              <master-data-select 
              label="Office" 
              group="GST_SALEOFFICE" 
              v-model="searchRequest.salesOffice"/>
            </div>

            <div class = "inputBox">
              <md-field>
                  <label>Order#</label>
                  <md-input 
                  v-model="searchRequest.deliveryOrder" 
                  @keyup.enter="doSearch"/>
                </md-field>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">
            <div class = "inputBox">
              <master-data-select 
                label="Order Type" 
                group="GST_DELIVERYTYPE" 
                v-model="searchRequest.deliveryType"/>
            </div>

            <div class = "inputBox">
              <md-field>
                <label>Customer PO</label>
                <md-input 
                v-model="searchRequest.customerPO" 
                @keyup.enter="doSearch"/>
              </md-field>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">  
            <div class = "inputBox">
              <master-data-select 
              label="Status" 
              group="GST_DO_STATUS" 
              v-model="searchRequest.deliveryStatus"/>
            </div>

            <div class = "inputBox">
              <md-field>
                  <label>Sort</label>
                  <md-input 
                  v-model="searchRequest.sort1" 
                  @keyup.enter="doSearch"/>
                </md-field>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">  
            <div class = "inputBox">
              <master-data-select 
              label="Process" 
              group="STC_DO_STATUS" 
              v-model="searchRequest.deleteBit"/>
            </div>

            <div class = "inputBox">
              <md-field>
                  <label>Booking</label>
                  <md-input 
                  v-model="searchRequest.bookObl" 
                  @keyup.enter="doSearch"/>
                </md-field>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">  
            <div class = "inputBox">
              <datepicker 
              v-model="searchRequest.cutLFD.startDate">
                <label>Cutoff From</label>
              </datepicker> 
            </div>
          </div>   

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-30"> 
            <div class = "inputBox">
              <datepicker 
                v-model="searchRequest.cutLFD.endDate">
                <label>CutOff To</label>
              </datepicker>
            </div>         
          </div>


          
      <WindowPortal v-model="deliveryOrderform"> 
        <button id="printf" onclick="window.print()">Print this page</button>
        <head>
          <title >DO_{{formHeader.deliveryType}}_{{formHeader.deliveryOrder}}</title>
        </head>
        <div class="page-header" >
          <div style= "height: 10px"></div>
          <h1 class = "heading1 centerPrint">STC Trucking Inc</h1>
          <div style= "height: 20px"></div>
          <div class = "border1">
            <div style= "height: 10px"></div>
            <div class = "fContainer" >
              <div class = "heading2"> Customer: {{ formHeader.customer }}  </div>
              <div class = "heading2"> IMPORT ORDER: {{formHeader.deliveryOrder}} </div>
            </div>
            <div style= "height: 30px"></div>
          </div>

          <div class = "border1">
            <div style="height: 10px"></div>
            <div class ="fContainer" >
              <div class = "heading2"> BK/BOL#:  {{ formHeader.bookObl }}  </div>
              <div class = "heading2"> LFD: {{formHeader.cutLFD | date}} </div>
            </div>
            <div style="height: 10px"></div>
            <div class ="fContainer" >
              <div class = "heading2"> </div>
              <div class = "heading2"> ERD: {{formHeader.erd | date}} </div>
            </div>
            <div style= "height: 30px"></div>
          </div>
          
          <div class = "border1">
            <div style="height: 10px"></div>
            <div class ="fContainer" >
              <div class = "heading2"> From: </div>
              <div class = "heading2"> To: </div>
              <div class = "heading2"> Return: </div>
            </div>
            <div style="height: 10px"></div>
            <div class ="fContainer" >
              <div class = "heading2"> {{ formHeader.ctnrPickup }} </div>
              <div class = "heading2"> {{ formHeader.customer }} </div>
              <div class = "heading2"> {{ formHeader.ctnrDropOff }} </div>
            </div>
            <div style= "height: 50px"></div>
          </div>  

          <div class = "border1">
            <div style="height: 10px"></div>
            <div class = "heading2"> Remark </div>
            <div style="height: 10px"></div>
            <div class = "heading2"> {{ formHeader.remark_bsi }} </div>
            <div style= "height: 30px"></div>
          </div>

          <div style="height: 30px"></div>
          <table>         
            <thead>
              <tr>
                <td>
                  <div class="page-header-space"></div>
                </td>
              </tr>
            </thead>  
         
            <tbody>
              <div class="border1 page">
                <table id="headertable">
                  <th class="header-cell left w12" >Container#</th>
                  <th class="header-cell left w12" >Size</th>
                  <th class="header-cell left w12" >Chassis#</th>
                </table>

                <div class="table-body ">
                  <table id="bodytable">
                    <tbody>
                      <tr :key="item.vueKey" v-for="item in formItem"  >
                        <td class="body-cell excelBoxprint w12">{{item.containerNo}}</td>  
                        <td class="body-cell excelBoxprint w12">{{item.ctnrType}}</td>
                        <td class="body-cell excelBoxprint w12">{{item.chassisNo}}</td>            
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </tbody>
          </table>  

          <div style="height: 50px"></div>
          <div class = "heading2">Driver Details </div>
          <div style="height: 20px"></div>
          <div class ="fContainer" >
            <div class = "heading2">_____________________</div>
            <div class = "heading2">__________________</div>
            <div class = "heading2">__________________ </div>
          </div>
          <div style="height: 10px"></div>
          <div class ="fContainer" >
            <div class = "heading2">Driver Signature</div>
            <div class = "heading2">Date/Time Arrived</div>
            <div class = "heading2">Date/Time Departed</div>
          </div>

          <div style="height: 20px"></div>
          <div class = "heading2">Customer Details </div>
          <div style="height: 20px"></div>
          <div class ="fContainer" >
            <div class = "heading2">_____________________</div>
            <div class = "heading2">__________________</div>
            <div class = "heading2">__________________ </div>
          </div>
          <div style="height: 10px"></div>
          <div class ="fContainer" >
            <div class = "heading2">Name (Please Print)</div>
            <div class = "heading2">Signature</div>
            <div class = "heading2">Date</div>
          </div>

          <div style="height: 20px"></div>
          <div class = "heading2">(Customer Agree that, unless otherwise noted herin, all goods were delivered in the same condition as pickup) </div>

        </div>

        
      </WindowPortal> 
        </div>  
      </md-card-content>
             
      <md-card-actions md-alignment="space-between">
        <div>
          <calling-api :paths="['/api/w/do/doheader/action', '/api/w/do/doitem', '/api/w/sqs/send']">
            <md-button v-if="getPermission.do.edit" class="md-raised" @click="doCreate"><span class="icons-center material-icons">fiber_new</span>New Do</md-button>
            <md-button v-if="getPermission.do.edit" class="md-raised" :disabled="!canCreateItem" @click="doChangeForm"><span class="icons-center material-icons">edit</span>Edit</md-button>
            <md-button v-if="getPermission.do.edit" class="md-raised" :disabled="!canCreateItem" @click="doCopyForm"><span class="icons-center material-icons">file_copy</span>Copy</md-button>
            <md-button v-if="getPermission.do.view || getPermission.doReadOnly.view" class="md-raised" :disabled="!canCreateItem" @click="doDO"><span class="icons-center material-icons">list</span>Item</md-button>
            <md-button v-if="getPermission.do.edit" class="md-raised" :disabled="!canCreateItem" @click="doCreateItem"><span class="icons-center material-icons">fiber_new</span>New Item</md-button> 
            <md-button v-if="getPermission.do.edit" class="md-raised" :disabled="!canCreateItem" @click="doRate"><span class="icons-center material-icons">attach_money</span>Rate</md-button>
            <md-button v-if="getPermission.do.edit || getPermission.doReadOnly.view" class="md-raised" :disabled="!canPrint" @click="doPrint"><span class="icons-center material-icons">print</span>Print</md-button>
            <md-button v-if="getPermission.do.edit" class="md-raised" @click="syncDO"><span class="icons-center material-icons">sync</span>Sync Do</md-button>
            <input type="text" placeholder="Filter Search" v-model="filter"/>
          </calling-api>
        </div>

        <div>
          <calling-api path="/api/w/do/doheader">
            <md-button class="md-raised md-primary btn-search-do-header" @click="doSearch">Search</md-button>
            <md-button class="md-raised" @click="clearSearch">Clear</md-button>
            <md-button class="md-icon-button" @click="mouseLeave" id="expand-button">
              <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
              <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
            </md-button>
          </calling-api>
        </div>
      </md-card-actions>
    </md-card>

    <pagination :items="getDoheaderToDisplay">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell center w2"></th>
                    <th class="header-cell center w2">Doc Due</th>
                      <th class="header-cell center w3" v-on:click="sortFunction('deliveryStatus')">Status</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('deleteBit')">Proc ess</th>
                      <th class="header-cell center w3" v-on:click="sortFunction('deliveryType')">Order Type</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('sort1')">Sort</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">Order#</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('customerPO')">CustPO</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('erd')">ERD</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('erd')">ERD Time</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('docCut')">DocCut</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('cutLFD')">Cutoff</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('cutLFD')">Cutoff Time</th>
                      <th class="header-cell center w6" v-on:click="sortFunction('bookObl')">BK</th>
                      <th class="header-cell center w10">BK Remark</th>
                      <th class="header-cell center w2">CTN</th>
                      <th class="header-cell center w2">ASN</th>
                      <th class="header-cell center w2">REM</th>
                      <th class="header-cell center w2">CType</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('pickupLoc')">Pickup Loc</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('deliveryTo')">Delivery To</th>
                      <th class="header-cell center w7" v-on:click="sortFunction('ctnrPickup')">Pickup Tml</th>
                      <th class="header-cell center w7" v-on:click="sortFunction('ctnrDropOff')">DropOff Tml</th>
                      <th class="header-cell center w3" v-on:click="sortFunction('scac')">SCAC</th>
                      <th class="header-cell center w7">Vessel</th>
                      <th class="header-cell center w5">Voyage</th>
                      <th class="header-cell center w3" v-on:click="sortFunction('arktx')">Grade</th>
                      <th class="header-cell center w3">Offsite Scale</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('zz_hqname')">Supplier</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('custID')">Customer</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('billTo')">Bill To</th>
                      <th class="header-cell center w5">Rate Agreement</th>
                      <th class="header-cell center w4">DO Date</th>
                      <th class="header-cell center w5">Office</th>
                      <th class="header-cell center w5">CreatedBy</th>
                      <th class="header-cell center w5">CreatedAt</th>
                      <th class="header-cell center w5">ChangedBy</th>
                      <th class="header-cell center w5">ChangedAt</th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vueKey" v-for="item in pageItems" v-bind:class ="{ selected: item.selected }">
                      <td class="body-cell excelBox w2"><md-checkbox v-model="item.selected"/></td>
                      <!-- <td class="body-cell excelBox w3"><master-data-display group="GST_DO_STATUS" :tag-id="item.deliveryStatus"/></td> -->
                      <td class="body-cell excelBox w2">
                        <template v-if="docCutDue >= item.docCut">🛑</template>
                      </td> 
                      <td class="body-cell excelBox w3">{{item.deliveryStatus}}</td>
                      <td class="body-cell excelBox w2">{{item.deleteBit}}</td>
                      <!-- <td class="body-cell excelBox w3"><master-data-display group="GST_DELIVERYTYPE" :tag-id="item.deliveryType"/></td> -->
                      <td class="body-cell excelBox w3">{{item.deliveryType}}</td>
                      <td class="body-cell excelBox w5">{{item.sort1}}</td>
                      <td class="body-cell excelBox w5">{{item.deliveryOrder}}</td>
                      <td class="body-cell excelBox w5">{{item.customerPO}}</td>
                      <td class="body-cell excelBox w4">{{item.erd | date}}</td>
                      <td class="body-cell excelBox w4">{{item.erd | time}}</td>
                      <!-- <td class="body-cell excelBox w4">{{item.docCut | date}}</td> -->
                      <td class="body-cell excelBox w4" v-if="item.docCut == null"></td>
                      <td class="body-cell excelBox w4" v-if="docCutDue < item.docCut">{{item.docCut | date}}</td>
                      <td class="body-cell excelBox w4" v-if="docCutDue >= item.docCut" style="background: rgb(243, 67, 67)">{{item.docCut | date}}</td>
                      <td class="body-cell excelBox w4">{{item.cutLFD | date}}</td>
                      <td class="body-cell excelBox w4">{{item.cutLFD | time}}</td>
                      <td class="body-cell excelBox w6">{{item.bookObl}}</td>
                      <td class="body-cell excelBox w10">{{item.remark_bsi}}</td>                    
                      <td class="body-cell excelBox w2">{{item.ctnrCount == null ? "0" : item.ctnrCount}}</td>
                      <td class="body-cell excelBox w2">{{item.ctnrAssign == null ? "0" : item.ctnrAssign}}</td>
                      <td class="body-cell excelBox w2">{{Number(item.ctnrCount) - Number(item.ctnrAssign)}}</td>
                      <!-- <td class="body-cell excelBox w5"><master-data-display group="CCR_CNTRTYPE" :tag-id="item.ctnrType"/></td> -->
                      <td class="body-cell excelBox w2">{{item.ctnrType}}</td>
                      <td class="body-cell excelBox w5"><master-data-display group="GST_LOCATION" :tag-id="item.pickupLoc"/></td>
                      <td class="body-cell excelBox w5"><master-data-display group="GST_LOCATION" :tag-id="item.deliveryTo"/></td>
                      <td class="body-cell excelBox w7"><master-data-display group="STC_TERMINAL" :tag-id="item.ctnrPickup"/></td>
                      <td class="body-cell excelBox w7"><master-data-display group="STC_TERMINAL" :tag-id="item.ctnrDropOff"/></td>
                      <td class="body-cell excelBox w3">{{item.scac}}</td>
                      <td class="body-cell excelBox w7">{{item.vesselName}}</td>
                      <td class="body-cell excelBox w5">{{item.voyage}}</td>
                      <td class="body-cell excelBox w3">{{item.arktx}}</td>
                      <td class="body-cell excelBox w3">{{item.zzsclost}}</td>
                      <td class="body-cell excelBox w5">{{item.zz_hqname}}</td>
                      <td class="body-cell excelBox w5"><master-data-display group="STC_CUSTOMER" :tag-id="item.custID"/></td>
                      <td class="body-cell excelBox w5"><master-data-display group="STC_CUSTOMER" :tag-id="item.billTo"/></td>
                      <td class="body-cell excelBox w5">{{item.agreement}}</td>
                      <td class="body-cell excelBox w4">{{item.erdat_mp | date}}</td>
                      <td class="body-cell excelBox w5">{{item.salesOffice}}</td>
                      <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                      <td class="body-cell excelBox w5">{{item.createdAt | date}}</td>
                      <td class="body-cell excelBox w5">{{item.updatedBy}}</td>
                      <td class="body-cell excelBox w5">{{item.updatedAt | date}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>

  </div>
</template>

<style scoped>
  #printf {
    background: rgb(239, 242, 147);
  }

  .fix {
    left: 0;
    position: -webkit-sticky;
    position: sticky;
    background: white;
  }

  .selected.selected {
      background: yellow;
    }

  .cl .md-field{
      display: inline-block !important;
      width: auto;
      margin-bottom: 10px;
      padding-top:10px;
  }

  .cl .md-field .md-input {
      font-size: 14px !important;
  }

  .inputBox {
    border: 1px solid #cacbcc;
    border-radius: px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }

  .header-cell {
    background: rgb(229, 231, 231);
  }

  .fContainer {
    /* border: 2px solid #448aff;
    border-radius: 15px; */
    display: flex;
    flex-direction: row;
    /* background-color:grey; */
  }

  .border1{
    border: 2px solid black;
  }
  .centerPrint {
    margin: auto;
    width: 100%;
    padding: 10px;
    text-align: center;
  }

  .heading1 {
    padding-top: 30px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 30px;
    font-family: Roboto Slab;
    margin: auto;
  }
  .heading2 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 16px;
    font-family: Roboto Slab;
    margin: auto;
  }



</style>

<script>
  import { mapGetters } from 'vuex';
  //import api from "../api";
  import { newAPIPost } from '../api';
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import DoHeaderForm from '../components/DoHeaderForm.vue';
  import DoItemForm from '../components/DoitemForm.vue'; 
  import WindowPortal from '../components/WindowPortal.vue';
  import dateFormat from '../utils/dateFormat';

  const getInitSearchRequest = () => ({
    deliveryStatus: null,
    deleteBit: null,
    deliveryType: null,
    salesOffice: "LGB",
    deliveryOrder: null,
    customerPO: null,
    bookObl: null,
    cutLFD: {
      startDate: moment().subtract(0,'months').startOf('d').toDate(),
      endDate: moment().add(3,'months').endOf('d').toDate(),
    },
    filter: "",
  
  });

  const getInitialrequestUpdateCnt= () => ({
    salesOffice: null,
    deliveryOrder: null,
  });

  export default {
    data: () => ({
      doTypeOptions: [
        {id: 'YE', name: 'Export',},
        {id: 'YY', name: 'Yard',},
        {id: 'YT',name: 'Truck',},
        {id: 'YI',name: 'Import',},
      ], 
      searchRequest: getInitSearchRequest(),
      items: [],
      formHeader: [],
      formItem: [],
      sortStatus: true,
      active: true,
      filter:"",
      trimOption: [
        "bookObl",
        "customerPO",
        "deliveryOrder"
      ],
      requestUpdateCnt: getInitialrequestUpdateCnt(),
      deliveryOrderform: false,
      docCutDue: dateFormat.getLocalDate(moment(moment().add(2,'days').startOf('d').toDate())),
    }),

    components: {
      AutocompleteCcicLocationSelect,
      callingApiCenter,
      DoItemForm,
      DoHeaderForm,
      WindowPortal,
    },


     watch: {
      getDoheader(val) {
        this.updateDoheader(val);
        },
      },

    computed: {
      ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getDoheader',
      ]),

      getDoheaderToDisplay(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(row.sort1).includes(term) ||
                  this.includeNull(row.deliveryOrder).includes(term) ||
                  this.includeNull(row.customerPO).includes(term) ||
                  this.includeNull(row.bookObl).includes(term) ||
                  this.includeNull(row.pickupLoc).includes(term) ||
                  this.includeNull(row.deliveryTo).includes(term) ||
                  this.includeNull(row.ctnrPickup).includes(term) ||
                  this.includeNull(row.ctnrDropOff).includes(term) ||
                  this.includeNull(row.scac).includes(term) ||
                  this.includeNull(row.arktx).includes(term) ||
                  this.includeNull(row.zz_hqname).includes(term) ||
                  this.includeNull(row.custID).includes(term) ||
                  this.includeNull(row.billTo).includes(term) ||
                  this.includeNull(row.agreement).includes(term);
                  
        })
      },

      getSelectedDoheader() {
        return _(this.items)
          .filter(it => it.selected);
      },

      canCreateItem() {
        if (this.getSelectedDoheader.length === 1)
        {
           return true
        }
        else
        {
          return false
        }
      },

      canPrint() {
        const item = _(this.items).filter((it) => it.selected);
        return item.length === 1 && item[0].deliveryType == 'YI'
      },
    },
   
   async mounted() {
      this.$el.querySelector('#searchTag').click();
      this.updateDoheader(this.getDoheader);
    },

    methods: {
      trimTool(ent) {
        return ent == null ? null : ent.trim()
      },

      mouseOver: function(){
        this.active = true;
      },

      mouseLeave: function() {
        this.active = !this.active;
      },

      sortFunction(sortFiled){
                const sorted = _(this.items).sortBy(sortFiled);
                console.log(this.sortStatus)
                this.sortStatus = !this.sortStatus;
                if (this.sortStatus)
                {
                    this.items = sorted;
                }
                else
                {
                    this.items = sorted.reverse();
                }
      },

      doDO(){
        this.requestUpdateCnt = getInitialrequestUpdateCnt();
        const request = this.getSelectedDoheader[0];
        this.$router.push({ 
            name: "Item" , 
            params:{
              salesOffice: request.salesOffice,
              deliveryOrder: request.deliveryOrder,
              deliveryType: request.deliveryType,
              customerPO: request.customerPO,
              bookObl: request.bookObl,
              // deleteBit: request.deleteBit,
              // from:this.searchRequest.cutLFD.startDate,
              // to:this.searchRequest.cutLFD.endDate,
            }})

            this.requestUpdateCnt.salesOffice = request.salesOffice
            this.requestUpdateCnt.deliveryOrder = request.deliveryOrder

            //api.post("/api/w/DOs/WebDoASNCount", this.requestUpdateCnt)
            newAPIPost("/api/w/DOs/WebDoASNCount", this.requestUpdateCnt)
              .then((res) => {
                this.$store.commit('clearApiError');
                this.showDialog = false;
                // window.confirm('DO container assign count updated.');
              });
      },

      syncDO(){
          //api.post('/api/w/sqs/send', {
          newAPIPost('/api/w/sqs/send', {
          cmd: "SYNC_DO",
          payload: null,
        })
      },

      doRate(){
       const request = this.getSelectedDoheader[0];
        if (request.agreement != null){
          request.mode = 'CHANGE';
          this.$router.push({ 
            name: "PriceMaint" , 
            params: request})
        }
        else{
          request.mode = 'CREATE';
          this.$router.push({ 
            name: "PriceMaint" , 
            params: request,})
        }
      },


      handleScroll(e) {
        $(this.$el.querySelector('.table-header')).offset({ left: -1 * (e.target.scrollLeft - $('.outer-container').offset().left) });
      },


      getDisplay(group, tagId) {
          if (!tagId) {
            return "";
          }
          return this.getMasterDataName(group, tagId) || this.tagId;
      },

      updateDoheader(items) {
        //this.doheaders = doheaders;
        var items = JSON.parse(JSON.stringify(items));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
      },
      
      doSearch() {
        this.items = [];
        this.active = true;
        if (this.searchRequest.cutLFD.startDate == null)
        {
          alert("Cut off day is required filed")
          return 
        }
        for (const el of this.trimOption) {
          this.searchRequest[el] = this.trimTool(this.searchRequest[el]);
        }

        this.$nextTick(() => {
          this.$store.dispatch('doheader', this.searchRequest).then(this.updateTableHeight);;
        });
      },

      clearSearch() {
        this.filter = "";
        this.searchRequest = getInitSearchRequest();
        this.items = this.getDoheader;
        this.updateDoheader(this.getDoheader);
        console.log(this.items);
      },

      async doChangeForm(){
           const request = this.getSelectedDoheader[0];
          this.$refs.DoHeaderFormChange.openDialog(request);
      },

      async doCopyForm(){
           const request = this.getSelectedDoheader[0];
          this.$refs.DoHeaderFormCopy.openDialog(request);
      },

      async doCreateItem(){
        const request = this.getSelectedDoheader[0];
        this.$refs.DoItemFormCreate.openDialog(request);

      },
      
      doCreate() {
        this.$refs.DoHeaderForm.openDialog();
      },

      includeNull(field){
            return field==null ? '' : field;
        },

      async doPrint(){
        this.formHeader = this.getSelectedDoheader[0];

        //this.formItem = await api.post('/api/w/do/doitem',
        this.formItem = await newAPIPost('/api/w/do/doitem',
                    { 
                      deliveryOrder: this.formHeader.deliveryOrder,
                    }
                  );


        this.formHeader.customer = this.getDisplay('STC_CUSTOMER', this.formHeader.custID);

        this.deliveryOrderform = true;



  
      },

    },
  };
</script>


